module.exports = __webpack_public_path__ + "assets/d82b8f054d411781d776a419fe936905.png";